import * as React from 'react';
import cn from 'classnames';
import styles from './styles.module.css';
import ReactModal from 'react-modal';
import { ButtonPrimary } from '../forms/Buttons';

const reactRootElement = document.getElementById('reactApp');

if (reactRootElement) {
  ReactModal.setAppElement(reactRootElement);
}

type Size = 'large' | 'medium';
export type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  onOpen?: () => void;
  onSubmit?: () => void;
  size?: Size;
  children?: React.ReactNode;
  overlayClassName?: string;
  shouldCloseOnOverlayClick?: boolean;
  onRequestClose?: () => void;
  okButtonText?: string;
  cancelButtonText?: string;
};

function getSizeStyle(size?: Size): string {
  switch (size) {
    case 'large':
      return styles.large;
    case 'medium':
      return styles.medium;
    default:
      return styles.large;
  }
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onOpen,
  onClose,
  onSubmit,
  size,
  title,
  children,
  okButtonText = 'OK',
  cancelButtonText = 'Cancel',
}) => {
  return (
    <>
      <ReactModal
        isOpen={isOpen}
        onAfterOpen={onOpen}
        onRequestClose={onClose}
        overlayClassName={styles.overlay}
        className={cn(styles.modal, getSizeStyle(size))}
      >
        <div className={cn(styles.title)}>
          {title}
          <a onClick={onClose}>
            <i
              className={cn(styles.cancelX, 'glyphicon', 'glyphicon-remove')}
            />
          </a>
        </div>
        <div className={cn(styles.content)}>
          {children}
          <div className={cn(styles.actions)}>
            {onSubmit ? (
              <>
                <ActionButton text={okButtonText} action={onSubmit} />
                <ActionButton text={cancelButtonText} action={onClose} />
              </>
            ) : (
              <ActionButton text={okButtonText} action={onClose} />
            )}
          </div>
        </div>
      </ReactModal>
    </>
  );
};

type ActionButtonProps = {
  text: string;
  action: () => void;
};

const ActionButton: React.FC<ActionButtonProps> = ({ text, action }) => (
  <div className={cn(styles.button)}>
    <ButtonPrimary onClick={action}>{text}</ButtonPrimary>
  </div>
);

export const modalContentStyle = {
  border: 'none',
  padding: '0px',
  width: '100%',
  background: 'none',
  alignSelf: 'unset'
};